import React, { useEffect, useState } from "react";
import { MultiSelect } from "../../../../_helpers/components/Forms/MultiSelect";
import {
    attachUserCategory,
    detachUserCategory,
    attachUserProject,
    detachUserProject,
    attachUserTeam,
    detachUserTeam,
} from "../../../../_api/Admin";
import { getEstablishments } from "../../../../_api/Company";
import { linkUserEstablishment } from "../../../../_api/Establishment";
import { getProjectsEstablishments } from "../../../../_api/Project";
import { getTeamEstablishments } from "../../../../_api/Team";
import { getCategories } from "../../../../_api/Category";
import toast from "react-hot-toast";
import { useOutletContext } from "react-router-dom";

const OrganisationTab = (props) => {
    const [user, setUser, currentApp, currentMenu, currentTab, setCurrentTab, setCurrentMenu] = useOutletContext();
    const features_right = user.policy.rights[currentApp][currentMenu.id]["sub_menu"]["INFOS"]["features"];

    const { profile, refreshProfil, onDataChange } = props;

    const [availablecategories, setAvailableCategories] = useState([]);
    const [availableTeams, setAvailableTeams] = useState([]);
    const [availableProjects, setAvailableProjects] = useState([]);

    const [categoriesSelected, setSelectCategories] = useState([]);
    const [teamsSelected, setSelectTeams] = useState([]);
    const [projectsSelected, setSelectProjects] = useState([]);
    const [establishmentsSelected, setEstablishmentsSelected] = useState([]);

    const [isActiveCategories, setIsActiveCategories] = useState(null);
    const [isActiveProjects, setIsActiveProjects] = useState(null);
    const [isActiveTeams, setIsActiveTeams] = useState(null);
    const [isActiveCompany, setIsActivityCompany] = useState(null);

    const [companies, setCompanies] = useState([]);

    useEffect(() => {
        onDataChange?.({
            establishmentsSelected,
            teamsSelected,
            projectsSelected,
            categoriesSelected,
        });
    }, [
        establishmentsSelected,
        categoriesSelected,
        teamsSelected,
        projectsSelected,
    ]);

    useEffect(() => {
        getEstablishments().then((resp) => {
            setCompanies(
                resp.data.map((data) => {
                    return { value: data.id, label: data.name };
                })
            );
        });
    }, []);

    useEffect(() => {
        if (profile) {
            if (profile.establishments.length > 0) {
                getProjectsEstablishments(profile.establishments[0].id).then((resp) => {
                    setSelectProjects(
                        profile.projects.map((resp) => {
                            return { value: resp.id, label: resp.name };
                        })
                    );
                    setAvailableProjects(
                        resp.data.map((data) => {
                            return { value: data.id, label: data.name };
                        })
                    );
                });

                getTeamEstablishments(profile.establishments[0].id).then((resp) => {
                    setSelectTeams(
                        profile.teams.map((resp) => {
                            return { value: resp.id, label: resp.name };
                        })
                    );
                    setAvailableTeams(
                        resp.data.map((data) => {
                            return { value: data.id, label: data.name };
                        })
                    );
                });
            }

            getCategories().then((resp) => {
                setSelectCategories(
                    profile.category
                        ? [
                              {
                                  value: profile.category.id,
                                  label: profile.category.name,
                              },
                          ]
                        : []
                );
                setAvailableCategories(
                    resp.data.map((data) => {
                        return { value: data.id, label: data.name };
                    })
                );
            });

            setEstablishmentsSelected(
                profile.establishments.map((data) => {
                    return { value: data.id, label: data.name };
                })
            );
        }
    }, [profile]);

    useEffect(() => {
        if (establishmentsSelected.length > 0) {
            getProjectsEstablishments(establishmentsSelected[0].value).then((resp) => {
                setAvailableProjects(
                    resp.data.map((data) => {
                        return { value: data.id, label: data.name };
                    })
                );
            });

            getTeamEstablishments(establishmentsSelected[0].value).then((resp) => {
                setAvailableTeams(
                    resp.data.map((data) => {
                        return { value: data.id, label: data.name };
                    })
                );
            });
        }
    }, [establishmentsSelected]);

    return (
        <div className="space-y-6">
            {/* Section Organisation */}
            <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                <div className="flex items-center mb-6">
                    <div className="flex items-center justify-center w-10 h-10 bg-emerald-100 rounded-lg mr-3">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-6 w-6 text-emerald-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                            />
                        </svg>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900">
                        Organisation
                    </h3>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Établissement */}
                    <div>
                        {features_right["entity_management"] && (
                            <MultiSelect
                                name={"Établissement"}
                                selections={establishmentsSelected}
                                options={companies}
                                value={""}
                                readOnly={
                                    profile?.establishments.length > 0
                                        ? true
                                        : false
                                }
                                isActive={isActiveCompany}
                                setActive={(val) => {
                                    setIsActivityCompany(val);
                                }}
                                addSelection={(option) => {
                                    if (!profile) {
                                        setSelectProjects([]);
                                        setSelectTeams([]);
                                        setSelectCategories([]);
                                        setEstablishmentsSelected([option]);
                                        setIsActivityCompany(false);
                                        return;
                                    }

                                    linkUserEstablishment(profile.id, option.value, "LINK")
                                        .then(() => {
                                            setSelectProjects([]);
                                            setSelectTeams([]);
                                            setSelectCategories([]);
                                            setEstablishmentsSelected([option]);
                                            setIsActivityCompany(false);
                                            refreshProfil?.();
                                        })
                                        .catch(() => {
                                            toast.error("Une erreur a eu lieu");
                                        });
                                }}
                                removeSelection={(option) => {
                                    if (!profile) {
                                        setSelectProjects([]);
                                        setSelectTeams([]);
                                        setSelectCategories([]);
                                        setEstablishmentsSelected([]);
                                        setIsActivityCompany(false);
                                        return;
                                    }

                                    linkUserEstablishment(profile.id, option.value, "DETACH")
                                        .then(() => {
                                            setSelectProjects([]);
                                            setSelectTeams([]);
                                            setSelectCategories([]);
                                            setEstablishmentsSelected([]);
                                            setIsActivityCompany(false);
                                            refreshProfil?.();
                                        })
                                        .catch(() => {
                                            toast.error("Une erreur a eu lieu");
                                        });
                                }}
                            />
                        )}
                    </div>

                    {/* Catégories */}
                    <div>
                        {features_right["entity_management"] && (
                            <MultiSelect
                                name={"Catégories"}
                                selections={categoriesSelected}
                                options={availablecategories}
                                value={""}
                                isActive={isActiveCategories}
                                setActive={(val) => {
                                    setIsActiveCategories(val);
                                }}
                                addSelection={(option) => {
                                    if (!profile) {
                                        setSelectCategories([option]);
                                        setAvailableCategories(
                                            availablecategories.filter(
                                                (available) =>
                                                    available.value !==
                                                    option.value
                                            )
                                        );
                                        setIsActiveCategories(false);
                                        return;
                                    }
                                    attachUserCategory(profile.id, option.value)
                                        .then((resp) => {
                                            setSelectCategories([option]);
                                            setAvailableCategories(
                                                availablecategories.filter(
                                                    (available) =>
                                                        available.value !==
                                                        option.value
                                                )
                                            );
                                            setIsActiveCategories(false);
                                        })
                                        .catch((resp) => {
                                            toast.error("Une erreur a eu lieu");
                                        });
                                }}
                                removeSelection={(option) => {
                                    if (!profile) {
                                        setAvailableCategories([
                                            option,
                                            ...availablecategories,
                                        ]);
                                        setSelectCategories(
                                            categoriesSelected.filter(
                                                (available) =>
                                                    available.value !==
                                                    option.value
                                            )
                                        );
                                        setIsActiveCategories(false);
                                        return;
                                    }
                                    detachUserCategory(profile.id, option.id)
                                        .then((resp) => {
                                            setAvailableCategories([
                                                option,
                                                ...availablecategories,
                                            ]);
                                            setSelectCategories(
                                                categoriesSelected.filter(
                                                    (available) =>
                                                        available.value !==
                                                        option.value
                                                )
                                            );
                                            setIsActiveCategories(false);
                                        })
                                        .catch((error) => {
                                            toast.error("Une erreur a eu lieu");
                                        });
                                }}
                            />
                        )}
                    </div>

                    {/* Projets */}
                    <div>
                        {features_right["entity_management"] && (
                            <MultiSelect
                                name={"Projets"}
                                selections={projectsSelected}
                                options={availableProjects}
                                value={""}
                                isActive={isActiveProjects}
                                setActive={(val) => {
                                    setIsActiveProjects(val);
                                }}
                                addSelection={(option) => {
                                    if (!profile) {
                                        setSelectProjects([
                                            option,
                                            ...projectsSelected,
                                        ]);
                                        setAvailableProjects(
                                            availableProjects.filter(
                                                (available) =>
                                                    available.value !==
                                                    option.value
                                            )
                                        );
                                        setIsActiveProjects(false);
                                        return;
                                    }
                                    attachUserProject(profile.id, option.value)
                                        .then((resp) => {
                                            setSelectProjects([
                                                option,
                                                ...projectsSelected,
                                            ]);
                                            setAvailableProjects(
                                                availableProjects.filter(
                                                    (available) =>
                                                        available.value !==
                                                        option.value
                                                )
                                            );
                                            setIsActiveProjects(false);
                                        });
                                }}
                                removeSelection={(option) => {
                                    if (!profile) {
                                        setAvailableProjects([
                                            option,
                                            ...availableProjects,
                                        ]);
                                        setSelectProjects(
                                            projectsSelected.filter(
                                                (available) =>
                                                    available.value !==
                                                    option.value
                                            )
                                        );
                                        setIsActiveProjects(false);
                                        return;
                                    }
                                    detachUserProject(profile.id, option.value)
                                        .then((resp) => {
                                            setAvailableProjects([
                                                option,
                                                ...availableProjects,
                                            ]);
                                            setSelectProjects(
                                                projectsSelected.filter(
                                                    (available) =>
                                                        available.value !==
                                                        option.value
                                                )
                                            );
                                            setIsActiveProjects(false);
                                        });
                                }}
                            />
                        )}
                    </div>

                    {/* Services */}
                    <div>
                        {features_right["entity_management"] && (
                            <MultiSelect
                                name={"Services"}
                                selections={teamsSelected}
                                options={availableTeams.filter((team) => !teamsSelected.some((selected) => selected.value === team.value))}
                                value={""}
                                isActive={isActiveTeams}
                                setActive={(val) => {
                                    setIsActiveTeams(val);
                                }}
                                addSelection={(option) => {
                                    if (!profile) {
                                        setSelectTeams([
                                            option,
                                            ...teamsSelected,
                                        ]);
                                        setIsActiveTeams(false);
                                        return;
                                    }
                                    attachUserTeam(profile.id, option.value)
                                        .then((resp) => {
                                            setSelectTeams([
                                                option,
                                                ...teamsSelected,
                                            ]);
                                            setIsActiveTeams(false);
                                        })
                                        .catch((resp) => {
                                            toast.error("Le salarié est déjà lié à l'équipe.");
                                        });
                                }}
                                removeSelection={(option) => {
                                    if (!profile) {
                                        setSelectTeams(
                                            teamsSelected.filter(
                                                (available) =>
                                                    available.value !==
                                                    option.value
                                            )
                                        );
                                        setIsActiveTeams(false);
                                        return;
                                    }
                                    detachUserTeam(profile.id, option.value)
                                        .then((resp) => {
                                            setSelectTeams(
                                                teamsSelected.filter(
                                                    (available) =>
                                                        available.value !==
                                                        option.value
                                                )
                                            );
                                            setIsActiveTeams(false);
                                        });
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrganisationTab;

